// extracted by mini-css-extract-plugin
export default {"lostItemFeePolicyForm":"lostItemFeePolicyForm---oAfbo"};